/**
 * Either localStorage or sessionStorage.
 */
export const authStorage: Storage = window.localStorage;
